import React from 'react';
import { AlertCircle, CheckCircle } from 'lucide-react';
import { AnswerQualityHint } from './AnswerQualityHint';

interface Step4Data {
  problem: string;
  solution: string;
}

interface Step4ProblemSolutionProps {
  data: Step4Data;
  onChange: (data: Step4Data) => void;
}

export function Step4ProblemSolution({ data, onChange }: Step4ProblemSolutionProps) {
  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <AlertCircle className="w-4 h-4 text-red-500" />
          Waar lopen je klanten tegenaan? Wat frustreert hen?
        </label>
        <textarea
          value={data.problem}
          onChange={(e) => onChange({ ...data, problem: e.target.value })}
          rows={5}
          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-lg resize-none"
          placeholder="Mensen willen gezond eten maar supermarktbrood zit vol E-nummers en toevoegingen. Ze hebben geen tijd om zelf te bakken en weten niet waar ze eerlijk ambachtelijk brood kunnen krijgen."
          autoFocus
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <CheckCircle className="w-4 h-4 text-green-500" />
          Hoe los jij dit op? Wat maakt jouw aanpak anders/beter?
        </label>
        <textarea
          value={data.solution}
          onChange={(e) => onChange({ ...data, solution: e.target.value })}
          rows={5}
          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-lg resize-none"
          placeholder="Wij bakken 100% natuurlijk, zonder rotzooi. Je bestelt online en binnen 2 uur bezorgen we vers brood bij je thuis. Geen gedoe, wel lekker en gezond. Transparant over alle ingrediënten."
        />
        <AnswerQualityHint length={data.problem.trim().length + data.solution.trim().length} />
      </div>
    </div>
  );
}
